export const INITIAL_LOADER_SET = 'INITIAL_LOADER_SET'
export const INITIAL_LOADER_IMAGE_SET = 'INITIAL_LOADER_IMAGE_SET'
